
const vishleSana:any = localStorage.getItem('vishleSana');

if(!vishleSana || vishleSana=="false"){
console.log = function () {}; // Disable console.log
console.error = function () {}; // Disable console.error 
console.warn = function () {};// Disable console.warn 
}

import('./bootstrap').catch((err) => console.error());
